import { status } from 'skin/event/status';
import { message } from 'skin/event';

const add = (obj) => {
	message('Добавление не активно', 'Цветовая гамма', null, '!');
	return status.ignore
};

export default add;
